@import 'styles/variables.scss';

.fieldWrapper {
  .numberInput {
    border-bottom: 1px solid $primary-color;
  }
}
